import { useState } from 'react';
import { apiAdminTestShipping } from '../../api/shipping';

const TestPanel = () => {
  const [form, setForm] = useState({ country: '', state: '', city: '', pincode: '', amount: '', itemCount: '', cod: false, shippingMethod: 'standard' });
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      const r = await apiAdminTestShipping(form);
      setResult(r);
    } catch (err) {
      setResult({ error: err.message });
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="bg-white border border-gray-200 rounded-lg p-4">
      <h3 className="text-sm font-bold text-black mb-3">Test estimate</h3>
      <div className="flex flex-wrap items-end gap-3">
        <span>
          <label className="block text-xs text-black mb-1">Country</label>
          <input
            type="text"
            value={form.country}
            onChange={(e) => setForm({ ...form, country: e.target.value.toUpperCase() })}
            className="border rounded px-2 py-1 text-sm w-20"
          />
        </span>
        <span>
          <label className="block text-xs text-black mb-1">Pincode</label>
          <input
            type="text"
            value={form.pincode}
            onChange={(e) => setForm({ ...form, pincode: e.target.value })}
            className="border rounded px-2 py-1 text-sm w-32"
          />
        </span>
        <span>
          <label className="block text-xs text-black mb-1">State</label>
          <input type="text" value={form.state} onChange={(e) => setForm({ ...form, state: e.target.value })} className="border rounded px-2 py-1 text-sm w-32" />
        </span>
        <span>
          <label className="block text-xs text-black mb-1">City</label>
          <input type="text" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} className="border rounded px-2 py-1 text-sm w-32" />
        </span>
        <span>
          <label className="block text-xs text-black mb-1">Delivery service</label>
          <select value={form.shippingMethod} onChange={(e) => setForm({ ...form, shippingMethod: e.target.value })} className="border rounded px-2 py-1 text-sm">
            <option value="standard">Standard</option>
            <option value="fast">Fast</option>
          </select>
        </span>
        <span>
          <label className="block text-xs text-black mb-1">Order amount</label>
          <input
            type="number"
            value={form.amount}
            onChange={(e) => setForm({ ...form, amount: e.target.value })}
            className="border rounded px-2 py-1 text-sm w-32"
          />
        </span>
        <span>
          <label className="block text-xs text-black mb-1">Item quantity</label>
          <input
            type="number"
            min="1"
            value={form.itemCount}
            onChange={(e) => setForm({ ...form, itemCount: e.target.value })}
            className="border rounded px-2 py-1 text-sm w-24"
          />
        </span>
        <label className="flex items-center gap-1 text-xs">
          <input
            type="checkbox"
            checked={form.cod}
            onChange={(e) => setForm({ ...form, cod: e.target.checked })}
          />
          COD
        </label>
        <button
          type="button"
          onClick={run}
          disabled={busy || !form.country || !form.pincode || !form.amount || !form.itemCount}
          className="bg-gray-800 text-white px-4 py-1.5 rounded text-sm hover:bg-gray-900 disabled:opacity-50"
        >
          {busy ? 'Running…' : 'Run'}
        </button>
      </div>
      {result && (
        <pre className="mt-3 bg-gray-100 rounded text-xs p-2 overflow-x-auto">
          {JSON.stringify(result, null, 2)}
        </pre>
      )}
    </section>
  );
};

export default TestPanel;
